import fileDownload from 'js-file-download';

const escape = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  const stringified = String(value).replace(/"/g, '""');

  return /[",\n\r]/.test(stringified) ? `"${stringified}"` : stringified;
};

const resolveDataIndex = (item, dataIndex) => {
  if (Array.isArray(dataIndex)) {
    return dataIndex.reduce((acc, key) => (acc == null ? acc : acc[key]), item);
  }

  return item?.[dataIndex];
};

export function downloadTableAsCsv({ columns, dataSource, filename }) {
  const exportableColumns = columns.filter((column) => column.csvRender || column.dataIndex);

  const header = exportableColumns
    .map((column) => escape(typeof column.title === 'string' ? column.title : column.key))
    .join(',');

  const rows = (dataSource || []).map((item) =>
    exportableColumns
      .map((column) => {
        const value = column.csvRender ? column.csvRender(item) : resolveDataIndex(item, column.dataIndex);

        return escape(value);
      })
      .join(','),
  );

  const csv = [header, ...rows].join('\n');
  const bom = String.fromCharCode(0xfeff);

  fileDownload(`${bom}${csv}`, filename, 'text/csv;charset=utf-8;');
}
